/**
 * Converts FAQ page admin HTML (h2 categories + h3 questions) into
 * accessible native <details>/<summary> accordions.
 */
(function () {
  function initFaqAccordions() {
    const content = document.querySelector('.ind-page-wrapper--faq .ind-page-content');
    if (!content || content.dataset.faqEnhanced === 'true') return;

    content.querySelectorAll('h2').forEach((heading) => {
      heading.classList.add('faq-category');
    });

    const questions = Array.from(content.querySelectorAll('h3'));
    questions.forEach((question, index) => {
      const details = document.createElement('details');
      details.className = 'faq-accordion';

      const summary = document.createElement('summary');
      summary.className = 'faq-accordion__summary';
      summary.id = 'faq-summary-' + (index + 1) + '-' + question.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      summary.textContent = question.textContent.trim();

      const answer = document.createElement('div');
      answer.className = 'faq-accordion__answer';
      answer.setAttribute('role', 'region');
      answer.setAttribute('aria-labelledby', summary.id);

      let sibling = question.nextElementSibling;
      while (sibling && sibling.tagName !== 'H3' && sibling.tagName !== 'H2') {
        const next = sibling.nextElementSibling;
        answer.appendChild(sibling);
        sibling = next;
      }

      question.replaceWith(details);
      details.append(summary, answer);

      details.addEventListener('toggle', () => {
        if (!details.open) return;

        content.querySelectorAll('.faq-accordion[open]').forEach((openDetails) => {
          if (openDetails !== details) openDetails.removeAttribute('open');
        });
      });
    });

    content.dataset.faqEnhanced = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqAccordions);
  } else {
    initFaqAccordions();
  }
})();
